import React, { useState, useEffect } from "react";
import "./login.scss";
import Modal from "react-bootstrap/Modal";
import { Link } from "react-router-dom";
import axios from "axios";
import { API_URL } from "../../utils/ApiUrl";
import Loader from "../../hooks/loader";
import { useHistory } from "react-router-dom";
import { toast } from "react-toastify";
import { useWeb3React } from "@web3-react/core";
import useAuth from "../../hooks/useAuth";
import CuurentRound from "../../hooks/chinaFunction/round";
import Timer from "../../hooks/chinaFunction/timer";
import { saveAddress } from "@sharemint/sdk";
import { storeReferrer } from "@sharemint/sdk";
const Login = () => {
  const { cuurentRound } = CuurentRound();
  const { timer } = Timer();
  var now11 = new Date();
  let createdDate = now11?.getTime();
  // console.log(createdDate,'createdDate');
  let currentTime = createdDate / 1000;
  currentTime = parseInt(currentTime);
  const [currentRoundd, setCurrentRoundd] = useState(null);
  let currentTime1 = new Date();
  const { login, logout } = useAuth();
  const { account } = useWeb3React();
  const history = useHistory();
  const [loaderr, setLoarder] = useState(false);
  const [show, setShow] = useState(false);
  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);
  const [show1, setShow1] = useState(false);
  const handleClose1 = () => setShow1(false);
  const handleShow1 = () => setShow1(true);
  const [inputFeild1, setInputFeild1] = useState(null);
  const [inputFeild6, setInputFeild6] = useState(null);
  const [currentRount, setCurrentRount] = useState(null);
  const [categoryScrollState, setCategoryScrollState] = useState(false);
  const [isCategoryLoading, setIsCategoryLoading] = useState(false);
  const [checkedNew, setCheckedNew] = useState(false);
  const [checkedNew1, setCheckedNew1] = useState(false);
  const [check, setChecked] = useState(false);
  const [niceName, setNicName] = useState(null);
  const userLogin = async () => {
    localStorage.setItem("email", inputFeild6);
    window.location.assign("/buy");
  };
  const inputField1Handler1 = (e) => {
    let value = e.target.value;
    setInputFeild1(value);
  };
  function isValidEmail(email) {
    return /\S+@\S+\.\S+/.test(email);
  }
  const inputField1Handler5 = (e) => {
    let value = e.target.value;
    if (!isValidEmail(value)) {
      setInputFeild6(value);
      setCheckedNew1(false);
    } else {
      setInputFeild6(value);
      setCheckedNew1(true);
    }
  };
  const safeDateta = async () => {
    let value = localStorage.getItem("sharemint");
    if (value) {
      saveAddress({ slug: "NFA", address: account });
    }
  };
  useEffect(() => {
    storeReferrer();
    return () => {};
  }, []);

  // useEffect(() => {
  //   // localStorage?.setItem('IsTomipay', false);
  //   if (account) {
  //     const connectorId = window.localStorage.getItem("connectorId")
  //     logout(connectorId);
  //     localStorage.removeItem("connectorId");
  //     localStorage.removeItem("flag");
  //   }
  // }, [account]);
  // for tomipay
  // useEffect(() => {
  //   localStorage?.setItem('IsTomipay', 'false');

  //   try{
  //   const handleMessage = (event) => {
  //     console.log('Received message:', event.data);
  //     if (event?.data?.includes('istomiPAY')) {
  //       localStorage?.setItem('IsTomipay', 'true');
  //       // alert(event.data)

  //     }
  //   };
  //   window.addEventListener('message', handleMessage);
  //   return () => {
  //     window.removeEventListener('message', handleMessage);
  //   };
  // }catch(err){
  //   console.log('err==========>>>',err)
  // }
  // }, []);

  // **********

  const [timeshow, setTimeshow] = useState(false);
  const [day, setDay] = useState(0);
  const [hour, setHour] = useState(0);
  const [min, setMin] = useState(0);
  const [sec, setSec] = useState(0);
  useEffect(() => {
    const interval = setInterval(() => {
      let now = "";
      let time = "";
      let diff = "";
      if (currentTime < new Date(parseInt(currentRount?.startTime))) {
        now = new Date();
        time = new Date(parseInt(currentRount?.startTime));
        diff = time.getTime() - parseInt(now.getTime() / 1000);
        setTimeshow(false);
      } else if (
        currentTime > new Date(parseInt(currentRount?.startTime)) &&
        currentTime < new Date(parseInt(currentRount?.endTime))
      ) {
        now = new Date();
        time = new Date(parseInt(currentRount?.endTime));
        diff = time.getTime() - parseInt(now.getTime() / 1000);
        setTimeshow(false);
        // console.log(diff);
      }
      if (diff <= 0) {
        if (currentTime < new Date(parseInt(currentRount?.startTime))) {
          window.location.reload();
        }

        setTimeshow(true);

        clearInterval(interval);
      }
      const days = Math.floor(diff / (60 * 60 * 24));
      const hours = Math.floor((diff % (60 * 60 * 24)) / (60 * 60));
      const mins = Math.floor((diff % (60 * 60)) / 60);
      const secs = Math.floor(diff % 60);
      setDay(days);
      setHour(hours);
      setMin(mins);
      setSec(secs);
    }, 1000);
    return () => clearInterval(interval);
  }, [currentRount]);

  const userLogin1 = async (e) => {
    // setLoarder(true);
    await axios
      .get(API_URL + "sale-rounds/users")
      .then(async (res) => {
        // setLoarder(false);
        let a = res.data.data;
        a.map((i) => {
          if (e == i?.round && i.privateSale == "ASTRANOVA") {
            setNicName(i.nickName);
          }
        });
        setTimeout(() => {
          // console.log("Delayed for 1 second.");
          setLoarder(false);
        }, "1000");
        // calucation(res.data.data)
        // console.log(res.data.data,'res.data.data');
      })
      .catch((err) => {
        console.log(err, "err");
        setLoarder(false);
        // setLoarder(false);
      });
  };
  const calucation = (e) => {
    // console.log(e,'imad');
    let dummy = [];
    let a = "";
    let indexx = "";
    let aaa = e.map((i, index) => {
      let tempLockedLending2 = "";
      if (
        currentTime > parseInt(i.startTime) &&
        currentTime < parseInt(i.endTime)
      ) {
        a = i;
        indexx = index + 1;
        let deff = currentTime - parseInt(i.startTime);
        tempLockedLending2 = { ...i, diffrence: deff, currentround: index + 1 };
        dummy.push(tempLockedLending2);
      } else {
        let deff = currentTime - parseInt(i.startTime);
        tempLockedLending2 = { ...i, diffrence: deff, currentround: index + 1 };
        dummy.push(tempLockedLending2);
      }
    });
    if (a) {
      // setPrice(a?.price/10**18)
      setCurrentRount(a);
      setCurrentRoundd(indexx);
      userLogin1(indexx);
      // setPrice(value?.price/10**18)
    } else if (dummy?.length > 0) {
      // dummy.sort((a, b) => {
      //   return a?.diffrence - b?.diffrence;
      // });
      setCurrentRount(dummy[0]);
      setCurrentRoundd(dummy[0]?.currentround);
      userLogin1(dummy[0]?.currentround);
      // setPrice(dummy[0]?.price/10**18)
    }
  };

  const [show2, setShow2] = useState(false);

  const handleClose2 = () => {
    setShow2(false);
    setCheked(false);
    setCheked1(false);
    setCategoryScrollState(false);
    setCheckedNew(false);
  };
  const handleShow2 = () => setShow2(true);
  const [cheked, setCheked] = useState(false);
  const [cheked1, setCheked1] = useState(false);
  const [cheked2, setCheked2] = useState(false);

  const inputField1Handler2 = (e) => {
    if (e.target.checked == true) {
      setCheked(true);
    } else {
      setCheked(false);
      setCheked1(false);
    }
  };
  const inputField1Handler3 = (e) => {
    if (e.target.checked == true) {
      setCheked1(true);
    } else {
      setCheked1(false);
    }
  };
  const inputField1Handler4 = (e) => {
    if (e.target.checked == true) {
      setCheked2(true);
    } else {
      setCheked2(false);
    }
  };

  const apiCheck = async (e) => {
    e?.preventDefault();
    const currentTime = new Date();
    if (inputFeild1 == 8707989948) {
      // console.log(value,'valuevaluevalue');
      localStorage.setItem("sharemint", inputFeild1);
    } else {
      localStorage.removeItem("sharemint");
    }

    setLoarder(true);
    const data = {
      accessCode: inputFeild1,
      privateSale: "ASTRANOVA",
    };
    await axios
      .post(API_URL + "users/verify-code", data)
      .then(async (res) => {
        console.log(res.data.data.data.code, "res");
        let dd = JSON.stringify(res.data.data.limit);
        localStorage?.setItem("oobjj", dd);
        localStorage?.setItem(
          "accessCode",
          res?.data?.data?.data?.code?.accessCode
        );
        localStorage?.setItem("role_ins", res?.data?.data?.data?.code?.role);
        localStorage?.setItem(
          "price_ins",
          res?.data?.data?.data?.allowedPrice?.tokenPrice
        );
        localStorage?.setItem(
          "timeeee",
          new Date(currentTime.getTime() + 24 * 3600000)
        );
        setLoarder(false);
        window.location.assign("/buy");
        // handleShow2();
        setCategoryScrollState(true);
      })
      .catch((err) => {
        console.log(err, "err");
        toast.error("Access code is not valid");
        setLoarder(false);
      });
  };

  const apiCheck11 = async (eee) => {
    // e?.preventDefault();
    const currentTime = new Date();
    if (eee == 8707989948) {
      // console.log(value,'valuevaluevalue');
      localStorage.setItem("sharemint", eee);
    } else {
      localStorage.removeItem("sharemint");
    }

    setLoarder(true);
    const data = {
      accessCode: eee,
      privateSale: "ASTRANOVA",
    };
    await axios
      .post(API_URL + "users/verify-code", data)
      .then(async (res) => {
        console.log(res.data.data.data.code, "res");
        let dd = JSON.stringify(res.data.data.limit);
        localStorage?.setItem("oobjj", dd);
        localStorage?.setItem(
          "accessCode",
          res?.data?.data?.data?.code?.accessCode
        );
        localStorage?.setItem("role_ins", res?.data?.data?.data?.code?.role);
        localStorage?.setItem(
          "price_ins",
          res?.data?.data?.data?.allowedPrice?.tokenPrice
        );
        localStorage?.setItem(
          "timeeee",
          new Date(currentTime.getTime() + 24 * 3600000)
        );
        setLoarder(false);
        window.location.assign("/buy");
        // handleShow2();

        setCategoryScrollState(true);
      })
      .catch((err) => {
        console.log(err, "err");
        toast.error("Access code is not valid");
        setLoarder(false);
      });
  };

  const handleCategoryScroll = () => {
    // console.log("hitting handle Scroll ");

    const element = document.querySelector(".scrolltext");
    if (
      element.scrollTop + element.clientHeight >= element.scrollHeight - 5 &&
      !isCategoryLoading
    ) {
      setIsCategoryLoading(true);
    }
  };

  useEffect(() => {
    if (isCategoryLoading) {
      // fetchCategoriesData();
      sxcrolll();
    }
    const scrollableElement = document.querySelector(".scrolltext");

    // console.log("scrolltext Element: ", scrollableElement);

    if (scrollableElement) {
      scrollableElement.addEventListener("scroll", handleCategoryScroll);
    }

    return () => {
      if (scrollableElement) {
        scrollableElement.removeEventListener("scroll", handleCategoryScroll);
      }
    };
  }, [isCategoryLoading, categoryScrollState]);

  const sxcrolll = () => {
    // console.log('completed');
    setIsCategoryLoading(false);
    setCheckedNew(true);
  };

  const firstTimeData = async () => {
    try {
      setLoarder(true);
      let b = await cuurentRound();

      if (b) {
        // setCurrentRoundd(b)
        roundData(b);
      }
    } catch (err) {
      console.log(err.message);
      setLoarder(false);
    }
  };
  useEffect(() => {
    setLoarder(true);
    const params = new URLSearchParams(window.location.search);
    const code = params.get("leader");
    if (code) {
      apiCheck11(code);
    } else {
      setLoarder(false);
    }
  }, []);
  useEffect(() => {
    firstTimeData();
    if (account) {
      safeDateta();
    }
  }, [account]);

  const roundData = async (e) => {
    // console.log(e,'eee');
    try {
      if (parseInt(e) <= 1) {
        // console.log('in if noor ',e);
        let c = await timer(e);

        if (c) {
          setCurrentRount(c);
          // setPrice(e?.price/10**18)
          setCurrentRoundd(e);
          userLogin1(e);

          setTimeout(() => {
            // console.log("Delayed for 1 second.");
            setLoarder(false);
          }, "1000");
          // setPrice(c.price/10**18)
          // console.log('nooor',c.price);
          // setCurrentTimer(c)
        }
      } else {
        let dummy = [];
        // console.log(e,'loooop bahis');
        for (let a = 1; a <= e; a++) {
          // console.log(a,'loooop');
          let c = await timer(a);
          dummy.push(c);
        }
        // console.log(dummy,'loooop');
        calucation(dummy);
      }
    } catch (err) {
      console.log(err, "erro in timer");
      setLoarder(false);
    }
  };

  const connectMetaMask1 = async () => {
    if (account) {
      const connectorId = window.localStorage.getItem("connectorId");
      await logout(connectorId);
      localStorage.removeItem("connectorId");
      localStorage.removeItem("flag");
    } else {
      login("injected");
      localStorage.setItem("connectorId", "injected");
      localStorage.setItem("flag", "true");
      handleClose1();
      setChecked(true);
    }
  };

  const trustWallet = async () => {
    if (account) {
      await logout("walletconnect");
      localStorage.clear();
    } else {
      try {
        login("walletconnect");
        handleClose1();
        setChecked(true);

        localStorage.setItem("connectorId", "walletconnect");
        localStorage.setItem("flag", "true");
      } catch (err) {
        console.log("eerr", err);
      }
    }
  };

  useEffect(() => {
    if (check) {
      clickAlready();
    }
  }, [account, cheked]);
  const clickAlready = () => {
    setLoarder(true);
    nftMainArryHandler2latestFromAdmin();
    // console.log(account,'account');
  };
  const nftMainArryHandler2latestFromAdmin = async () => {
    setLoarder(true);
    var data = JSON.stringify({
      query: `query MyQuery {
        purchases(
          orderBy: blockTimestamp
    orderDirection: desc
          where: {by: "${account}"}) {
            type
            transactionHash
            tokenSelected
            tokenPurchased
            tokenPrice
            token
            roundPrice
            round
            nftAmounts
            id
            code
            by
            blockTimestamp
            amountPurchased
        }
      }`,
      variables: {},
    });
    var config = {
      method: "post",
      url: "https://api.studio.thegraph.com/query/63987/asro-nova-v2/version/latest",
      headers: {
        "Content-Type": "application/json",
      },
      data: data,
    };
    await axios(config)
      .then(async function (response) {
        let a = response?.data?.data?.purchases;
        nftMainArryHandler2latestFromAdmin1(a);
      })
      .catch(function (error) {
        setLoarder(false);
        console.log(error, "error");
      });
  };

  const nftMainArryHandler2latestFromAdmin1 = async (e) => {
    var data = JSON.stringify({
      query: `query MyQuery {
        purchases(
          orderBy: blockTimestamp
    orderDirection: desc
          where: {by: "${account}"}) {
            type
            transactionHash
            tokenSelected
            tokenPurchased
            tokenPrice
            token
            roundPrice
            round
            nftAmounts
            id
            code
            by
            blockTimestamp
            amountPurchased
        }
      }`,
      variables: {},
    });
    var config = {
      method: "post",
      url: "https://subgraph.satsuma-prod.com/323ce71d2cc0/usman--186639/astro-nova-live/api",
      headers: {
        "Content-Type": "application/json",
      },
      data: data,
    };
    await axios(config)
      .then(async function (response) {
        let a = response?.data?.data?.purchases;
        let c = e.concat(a);
        setLoarder(false);
        // nftMainArryHandler2(a)

        if (c.length > 0) {
          window.location.assign("/claim");
        } else {
          toast.warning("No Claim Found");
        }
        // ClaimAll111();
        // settotalArry(response?.data?.data?.investments);
        // instittion(a)
      })
      .catch(function (error) {
        console.log(error, "error");
        setLoarder(false);
      });
  };
  const instittion = async (e) => {
    var data = JSON.stringify({
      query: `query MyQuery {
        purchases(
          orderBy: blockTimestamp
    orderDirection: desc
        where: {recipient: "${account}"}) {
          transactionHash
    tokenSelected
    tokenPurchased
    tokenPrice
    token
    recipient
    price
    id
    code
    by
    blockTimestamp
    amountPurchased
        }
      }`,
      variables: {},
    });
    var config = {
      method: "post",
      url: "https://api.studio.thegraph.com/query/63987/leia-institution/1",
      headers: {
        "Content-Type": "application/json",
      },
      data: data,
    };
    await axios(config)
      .then(async function (response) {
        setLoarder(false);
        // console.log(response, 'response?.data?.data?.investments mainn1 sddasasa');
        let a = response?.data?.data?.purchases;
        let c = e.concat(a);
        // console.log(c,'ccccc');
        if (c.length > 0) {
          window.location.assign("/claim");
        } else {
          toast.warning("No Claim Found");
        }
        // settotalArry(a);
        // setMainLoader1(false);
        // ClaimAll111();
        // settotalArry(response?.data?.data?.investments);
        // instittion(response?.data?.data?.investments)
      })
      .catch(function (error) {
        setLoarder(false);
        console.log(error, "error");
      });
  };

  return (
    <>
      {loaderr && <Loader />}
      <section className="login-screen">
        <video
          className="main-banner-video"
          muted="muted"
          playsinline="playsinline"
          autoPlay
          loop
          width="100%"
          id="myVideo"
        >
          <source src="/loginvideo.mp4" type="video/mp4" />
        </video>
        <span className="bannershade"></span>
        {/* <img
          src="\assets\homepage-bg.png"
          alt="img"
          className="img-fluid login-bg"
        />
        <img
          src="\assets\mblviewbg.png"
          alt="img"
          className="img-fluid mblviewbanner-bg d-none"
        /> */}
        <div className="upper-logo ">
          <div className="container">
            <div className=" set-flex">
              <img src="\logo.svg" alt="img" className="img-fluid" />
              {!account ? (
                <a onClick={handleShow1}>Already Purchased?</a>
              ) : (
                <a onClick={clickAlready}>Already Purchased?</a>
              )}
            </div>
          </div>
        </div>
        <div className="container">
          <div className="timermain">
            <div className="timerleft">
              <div className="mainiconimg">
                <img
                  src="\assets\newincentivlogo.svg"
                  alt="iconimginner"
                  className="iconimginner"
                />
              </div>
              <div className="mainicontexts">
                <h6 className="timerhead">Astra Nova</h6>
                <p className="timerpara">$RVV</p>
                {/* <p className="timerpara">Round  {niceName} starts on:</p> */}
              </div>
            </div>
            <div className="forflexmain">
              {currentTime < new Date(parseInt(currentRount?.startTime)) ? (
                <p className="timerpara">Round {niceName} Starts in:</p>
              ) : (
                <>
                  {currentTime > new Date(parseInt(currentRount?.startTime)) &&
                  currentTime < new Date(parseInt(currentRount?.endTime)) ? (
                    <p className="timerpara">Round {niceName} Ends in:</p>
                  ) : (
                    ""
                  )}
                </>
              )}
              {timeshow ? (
                <p className="timerended"> Sale ended!</p>
              ) : (
                <p className="innertimertext">
                  {day ? day : 0}D : {hour ? hour : 0}H : {min ? min : 0}M :{" "}
                  {sec ? sec : 0}S
                </p>
              )}
            </div>
          </div>

          <form onSubmit={(e) => apiCheck(e)} className="w-100">
            <div className="bottom-card">
              {/* <img
              src="\assets\card-logo.svg"
              alt="img"
              className="img-fluid scvtsvctsc"
            /> */}
              <h6>Enter access code to continue</h6>
              <div className="material-textfield">
                <input
                  onChange={inputField1Handler1}
                  value={inputFeild1}
                  type="text"
                  placeholder="Enter access code"
                />
              </div>

              {inputFeild1 ? (
                <button className=" newClass" type="submit">
                  Continue
                </button>
              ) : (
                <button className="btn-continue" type="button">
                  Continue
                </button>
              )}
            </div>
          </form>
        </div>
        <div className="loginfooter">
          <div className="custom-container">
            <div className="innerloginfooter">
              <img src="/logo.svg" alt="logoimg" className="logoimg" />
              <p className="footerpara">©2025 GEMS. All rights reserved</p>
            </div>
          </div>
        </div>
      </section>

      <Modal
        className="connectwallet-modal"
        show={show}
        onHide={handleClose}
        centered
      >
        <Modal.Header closeButton>
          <Modal.Title>Connect Wallet</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="twice-btns">
            <button>
              <img src="\assets\metamask.svg" alt="img" className="img-fluid" />
              <h6>Metamask</h6>
            </button>
            <button>
              <img
                src="\assets\walletconnect.svg"
                alt="img"
                className="img-fluid"
              />
              <h6>WalletConnect</h6>
            </button>
          </div>
        </Modal.Body>
      </Modal>
      <Modal
        className="connectwallet-modal nooreee"
        show={show2}
        onHide={handleClose2}
        centered
        backdrop="static"
      >
        <Modal.Header>
          <Modal.Title>
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="24"
              height="25"
              viewBox="0 0 24 25"
              fill="none"
              className="mr-2"
            >
              <rect y="0.5" width="24" height="24" rx="4" fill="#E88F35" />
              <path
                d="M10.0001 2.5L13.4199 4.40802L13.5063 17.6429L10.0866 15.7348L10.0001 2.5Z"
                fill="white"
              />
              <path
                d="M10.0001 17.604L13.4199 19.512L13.5063 21.604L10.0866 19.696L10.0001 17.604Z"
                fill="white"
              />
            </svg>
            PRIVATE SALE AGREEMENT
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="darktext">
            <div className="scrolltext">
              <p className="darkparaupper text-center">Terms Of Service</p>
              <p className="darkpara text-center">
                Last Updated: [Septmber 10, 2024]
              </p>
              <p className="darkpara">
                1.
                <span className="headingtext formarginleft">Introduction</span>
              </p>
              <p className="darkpara">
                These Terms of Service, together with any other agreements or
                terms incorporated by reference, including our Privacy Policy
                (available here) (these “Terms”) govern your access to and use
                of the Gems platform, available at https://gems.vip/, (the
                “Platform”), owned and operated by Gems Labs Limited d/b/a Gems
                (“Gems,” “we,” “us”, or “our”) and any software, tools,
                features, or functionalities provided on or in connection with
                our services; including without limitation using our services,
                at your own discretion, to view, explore and or/purchase
                blockchain tokens (the “Tokens”) associated with various
                projects which may be made available on our Platform from time
                to time (collectively, the “Service”).{" "}
              </p>
              <p className="darkpara">
                For purposes of these Terms, “user”, “you”, and “your” mean you
                as the user of the Service. If you use the Service on behalf of
                a company or other entity then “you” includes you and that
                entity, and you represent and warrant that (a) you are an
                authorized representative of the entity with the authority to
                bind the entity to these Terms, and (b) you agree to these Terms
                on the entity’s behalf.
              </p>
              <p className="darkpara">
                BY USING THE PLATFORM AND/OR SERVICE, YOU AGREE TO BE BOUND BY
                THESE TERMS AND ALL OF THE TERMS INCORPORATED HEREIN BY
                REFERENCE. IF YOU DO NOT AGREE TO THESE TERMS, YOU MAY NOT
                ACCESS OR USE THE PLATFORM AND/OR SERVICE.
              </p>
              <p className="darkpara">
                Please refer to our Privacy Policy for information about how we
                collect, use, and share information from and/or about you (“Your
                Data”). By submitting Your Data through our Service, you agree
                to the terms of our Privacy Policy and you expressly consent to
                the collection, use, and disclosure of Your Information in
                accordance with the Privacy Policy.
              </p>
              <p className="darkpara">
                Gems is not a wallet provider, exchange, broker, dealer,
                financial institution, payments processor, money services
                business, or creditor. Gems showcases curated blockchain
                projects (each, a “Project”) and allows you to participate in
                the sale of their Tokens. We do not have custody or control over
                the Tokens or blockchains you are interacting with and we do not
                execute or effectuate purchases, transfers, or sales of Tokens.
                To use our Service, you must use a third-party wallet which
                allows you to engage in transactions on blockchains and you are
                responsible for obtaining and maintaining the security of such
                wallet and its keys.
              </p>
              <p className="darkpara">
                Gems is not a party to any agreement between you and the
                Project. You bear full responsibility for engaging with or
                purchasing of Tokens from to any Project and acquiring their
                Tokens, which in each case, may only be facilitated by acquiring
                a valid referral code from third-party promoters (each, a
                “Leader”) and we make no claims, guarantees, or recommendations
                about the identity, legitimacy, functionality, or authenticity
                of Leaders or Tokens (and any Projects or teams associated with
                such Tokens) visible on the Service.
              </p>
              <p className="darkpara">
                Because we have a growing number of services, we may, from time
                to time, provide additional terms for specific services (and
                such services are deemed part of the “Service” hereunder and
                shall also be subject to these Terms). Those additional terms
                and conditions, which are available with the relevant service,
                then become part of your agreement with us if you use those
                services. In the event of a conflict between these Terms and any
                additional applicable terms we may provide for a specific
                service, such additional terms shall control for that specific
                service.
              </p>
              <p className="darkpara">
                Gems reserves the right to change or modify these Terms at any
                time and in our sole discretion. If we make material changes to
                these Terms, we will use reasonable efforts to provide notice of
                such changes, such as by providing notice through the Platform
                or updating the “Last Updated” date at the beginning of these
                Terms. By continuing to access or use the Service, you confirm
                your acceptance of the revised Terms and all of the terms
                incorporated therein by reference effective as of the date these
                Terms are updated. It is your sole responsibility to review the
                Terms from time to time to view such changes and to ensure that
                you understand the terms and conditions that apply when you
                access or use the Service. We further reserve the right in our
                sole discretion to modify, suspend, or discontinue, temporarily
                or permanently, the Service (or any features or parts thereof)
                at any time and without liability as a result.
              </p>
              <p className="darkpara">
                2.
                <span className="headingtext formarginleft">
                  Accessing the Service
                </span>
              </p>
              <p className="darkpara">
                Your blockchain address functions as your identity on Gems.
                Accordingly, you will need a blockchain address and a
                third-party wallet to access the Service. Your account on the
                Platform (“Account”) will be associated with your linked
                blockchain address and will display the Tokens for that
                blockchain address (and, if applicable, any content associated
                with such Tokens). By using your wallet in connection with the
                Service, you agree that you are using that wallet under the
                terms and conditions of the applicable provider of the wallet.
                Wallets are not operated by, maintained by, or affiliated with
                Gems, and Gems does not have custody or control over the
                contents of your wallet and has no ability to retrieve or
                transfer its contents. Gems accepts no responsibility for, or
                liability to you, in connection with your use of a wallet and
                makes no representations or warranties regarding how the Service
                will operate with any specific wallet. You are solely
                responsible for keeping your wallet secure and you should never
                share your wallet credentials or seed phrase with anyone. If you
                discover an issue related to your wallet, please contact your
                wallet provider. Likewise, you are solely responsible for your
                Account and any associated wallet and we are not liable for any
                acts or omissions by you in connection with your Account or as a
                result of your Account or wallet being compromised. You agree to
                immediately notify us if you discover or otherwise suspect any
                security issues related to the Service or your Account, by
                sending an email to:{" "}
                <a href="mailto: Info@gems.vip">Info@gems.vip</a>.
              </p>
              <p className="darkpara">
                You also represent and warrant that you will comply with all
                applicable laws (e.g., local, state, federal and other laws) in
                connection with using the Service. In order to comply with our
                legal obligations and keep our users and platform safe, we may
                need to restrict, suspend, or terminate your access to the
                Service. You acknowledge that Gems is under no obligation to
                disclose the details of its decision to take such action with
                you.
              </p>
              <p className="darkpara">
                Without limiting the foregoing, by using the Service, you
                represent and warrant that:
              </p>

              <p className="darkpara">
                <span className="headingtext formarginleft">a.</span> You are
                not, and have not been involved in any type of activity
                associated with money laundering or terror financing, nor
                violated any provision of the U.S. Foreign Corrupt Practices Act
                of 1977, as amended, the UK Bribery Act (2010), or any other
                applicable anti-corruption or anti bribery legislation, nor were
                you ever subject, to any investigation by, or have received a
                request for information from any governmental body relating to
                corruption or bribery under any statute and you hereby consent
                to Gems running any checks or enquiries with third parties and
                you waive any privacy or other right in connection therewith and
                acknowledge that any breach of this representation by you will
                entitle Gems to terminate these Terms with immediate effect;
              </p>

              <p className="darkpara">
                <span className="headingtext formarginleft">b.</span> You have
                carefully reviewed, understand, and accept the various risks of
                entering into these Terms, including, but not limited to, the
                risks detailed in Section 8, below;
              </p>

              <p className="darkpara">
                <span className="headingtext formarginleft">c.</span> You have
                not relied on any representations or warranties made by Gems or
                any representative thereof, including, but not limited to,
                conversations of any kind, whether through oral or electronic
                communication, or any whitepaper or similar document;
              </p>

              <p className="darkpara">
                <span className="headingtext formarginleft">d.</span> You are
                not a citizen, resident, or an entity incorporated in a
                geographic area in which the purchase, access to, or use of the
                Tokens is prohibited by applicable law, decree, regulation,
                treaty, or administrative act;
              </p>

              <p className="darkpara">
                <span className="headingtext formarginleft">e.</span> Neither
                you, nor any of your affiliates, shareholders, direct or
                indirect owners, or beneficiaries are located in, resident in,
                or incorporated under the laws of Afghanistan, Belarus, Burundi,
                Central African Republic, Congo (the Democratic Republic of the
                Congo), Cuba, Guinea, Guinea-Bissau, Haiti, Hong Kong, Iran,
                Iraq, the Democratic People's Republic of Korea (North Korea),
                Lebanon, Libya, Mali, Myanmar (Burma), Nicaragua, Somalia, South
                Sudan, Sudan, Syria, Taiwan, Venezuela, Western Sahara, Yemen,
                Zimbabwe; the Krim, Donetsk, Kherson and Luhansk regions of
                Ukraine, the United States of America or any jurisdiction which
                is the target of such comprehensive, country-wide or
                territory-wide Sanctions as currently apply to the
                aforementioned countries or any country or territory that has
                been designated as non-cooperative with international anti-money
                laundering principles or procedures by an intergovernmental
                group or organization, such as the Financial Action Task Force
                on Money Laundering (“FATF”) (each, a “Restricted
                Jurisdiction”).
              </p>

              <p className="darkpara">
                <span className="headingtext formarginleft">f.</span> Neither
                you, nor any of your affiliates, shareholders, direct or
                indirect owners, or beneficiaries is the target of any Sanctions
                laws, regulations, embargoes, or restrictive measures (the
                “Sanctions”), as amended from time to time, administered,
                enacted, or enforced by: the United Nations, the United States
                of America, the European Union or any Member State thereof, the
                United Kingdom or the respective Governmental Authorities of any
                of the foregoing responsible for administering, enacting or
                enforcing Sanctions, including without limitation, OFAC, the US
                Department of State or the United Kingdom Treasury (the
                “Sanctions Authority”);
              </p>

              <p className="darkpara">
                <span className="headingtext formarginleft">g.</span> Neither
                you, nor any of your affiliates, shareholders, direct or
                indirect owners, or beneficiaries is listed on any of the
                following lists (each a “Sanctions List”): the Consolidated
                United Nations Security Council Sanctions List; the Specially
                Designated Nationals and Blocked Persons List or the Sectoral
                Sanctions Identification List maintained by the US Office of
                Foreign Assets Control (OFAC); the Consolidated List of Persons,
                Groups and Entities subject to EU Financial Sanctions; the
                Consolidated List of Financial Sanctions Targets or List of
                persons subject to restrictive measures in view of Russia's
                actions destabilizing the situation in Ukraine, maintained by
                the United Kingdom Treasury or any similar list maintained by,
                or public announcement of sanctions made by, any other Sanctions
                Authority.;
              </p>

              <p className="darkpara">
                <span className="headingtext formarginleft">h.</span> Neither
                you, nor any of your affiliates, shareholders, direct or
                indirect owners, or beneficiaries is owned or controlled by, or
                acting on behalf of or for the benefit of, any person on a
                Sanctions List or who is a citizen, resident, or incorporated in
                any Restricted Jurisdiction.
              </p>

              <p className="darkpara">
                <span className="headingtext formarginleft">i.</span> You
                represent to Gems that you purchase the Tokens as utility
                tokens, in order to use them in the Project upon its launch, and
                not as an investment, a security, a financial product or an
                instrument that may be expected to accrue value, have secondary
                market, be sold, traded or have any utility, usage, value or
                usability other than its utility in the Project.
              </p>

              <p className="darkpara">
                <span className="headingtext formarginleft">j.</span> You
                covenant that any amounts used to purchase Tokens of the various
                Projects listed on the Platform will not be sourced from assets,
                funds, or accounts located in any Restricted Jurisdiction.
              </p>

              <p className="darkpara">
                <span className="headingtext formarginleft">k.</span> You agree
                that we may, in our own discretion and in accordance with our
                internal compliance and risk management protocols, where we have
                any reason to suspect that any of the items above might not be
                accurate, take any appropriate action in connection with your
                Account, including but not limited to suspending or terminating
                the access to your Account or any use of the Service. We may
                further require you to provide any information or documentation,
                including identifying documentation about yourself, your
                Account, the funds used by you as part of the Service, and any
                other relevant information.
              </p>

              <p className="darkpara">
                <span className="headingtext formarginleft">l.</span> Any
                information provided by you shall be at all times complete,
                accurate and not misleading.
              </p>

              <p className="darkpara">
                Finally, by using the Service, you understand the importance of
                DYOR – doing your own research. You bear full responsibility for
                verifying the authenticity, legitimacy, identity, and other
                details about any Token or Project that you view or otherwise
                interact with in conjunction with our Service. We make no
                claims, guarantees or recommendations about the identity,
                legitimacy, or authenticity of any Token, Project, or account on
                the Service.
              </p>
              <p className="darkpara">
                WITHOUT LIMITING THE GENERALITY OF THE FOREGOING, YOU ASSUME ALL
                RISK AND LIABILITY FOR THE RISKS OF ENTERING INTO THESE TERMS
                AND THE RESULTS OBTAINED BY THE USE OF THE TOKENS AND REGARDLESS
                OF ANY ORAL OR WRITTEN STATEMENTS MADE BY GEMS, ANY GEMS
                ASSOCIATED PERSON OR ANY GEMS REPRESENTATIVE, INCLUDING IN THE
                FORM OF TECHNICAL ADVICE OR OTHERWISE, RELATED TO THE USE OF THE
                TOKENS.
              </p>
              <p className="darkpara">
                3.<span className="headingtext formarginleft">Ownership</span>
              </p>
              <p className="darkpara">
                The Service, including its “look and feel” (e.g., text,
                graphics, images, logos, page headers, button icons, urls, and
                scripts), proprietary content, information and other materials,
                and all content and other materials contained therein,
                including, without limitation, the Gems logo and all designs,
                text, graphics, pictures, data, software, sound files, other
                files, and the selection and arrangement thereof are the
                proprietary property of Gems or our affiliates, licensors, or
                users, as applicable, and you agree not to take any action(s)
                inconsistent with such ownership interests. We and our
                affiliates, licensors, and users, as applicable, reserve all
                rights in connection with the Service and its content,
                including, without limitation, the exclusive right to create
                derivative works.
              </p>
              <p className="darkpara">
                Gems’s name, logo, trademarks, and any Gems product or service
                names, designs, logos, and slogans are the intellectual property
                of Gems or our affiliates or licensors and may not be copied,
                imitated or used, in whole or in part, without our prior written
                permission in each instance. You may not use any metatags or
                other “hidden text” utilizing “Gems” or any other name,
                trademark or product or service name of Gems or our affiliates
                or licensors without our prior written permission. In addition,
                the “look and feel” of the Service constitutes the service mark,
                trademark or trade dress of Gems and may not be copied, imitated
                or used, in whole or in part, without our prior written
                permission.
              </p>
              <p className="darkpara">
                All other third-party trademarks, registered trademarks, and
                product names mentioned on the Service or contained in the
                content linked to or associated with any Tokens displayed on the
                Service are the property of their respective owners and may not
                be copied, imitated or used, in whole or in part, without the
                permission of the applicable intellectual property rights
                holder. Reference to any products, services, processes or other
                information by name, trademark, manufacturer, supplier or
                otherwise does not constitute or imply endorsement, sponsorship,
                or recommendation by Gems.
              </p>
              <p className="darkpara">
                To the extent You provide us any feedback, comments or
                suggestions ("Feedback"), you grant us a royalty-free, fully
                paid up, worldwide, perpetual and irrevocable license to
                incorporate the Feedback into the Services or any of our current
                or future products or services.
              </p>
              <p className="darkpara">
                Gems does not have ownership, custody, or control of Tokens or
                the smart contracts deployed by third parties. Creators of these
                Tokens or smart contracts are solely responsible for their
                operation and functionality.
              </p>
              <p className="darkpara">
                You are hereby granted a limited, nonexclusive, non
                transferable, non sublicensable, and personal license to access
                and use the Service provided, however, that such license is
                subject to your compliance with these Terms.
              </p>
              <p className="darkpara">
                The Tokens will be claimed by you at a later date, to be
                communicated via the Service. You are responsible for making the
                claim. Claims which are not claimed within a certain timeframe
                may be void. We may request additional information, as well as
                KYC, upon the claim and facilitation thereof may be contingent
                on providing such information to us or any third party, in full.
              </p>
              <p className="darkpara">
                We further reserve the right not to accept any purchase of
                Tokens which does not comply with our terms of use, or that we
                otherwise deem, at our sole and final discretion, incompatible
                with applicable laws, regulations, project requirements, carry
                high level of risk, origin from Restricted Jurisdictions or from
                Purchasers included in Sanctioned Lists. Each Purchaser may be
                required, at our sole and final discretion, to undergo a KYC
                process and to provide additional information and documents for
                such purpose, and each transaction may undergo a KYT screening.
                Users and transactions that will fail to meet our requirements
                may, at our sole discretion, not be able to claim the Tokens,
                and the funds used for the Purchase of Tokens may be confiscated
                and seized or refunded to you, at our sole discretion.
              </p>
              <p className="darkpara">
                4.
                <span className="headingtext formarginleft">
                  Third-Party Content, Agreements, and Services
                </span>
              </p>
              <p className="darkpara">
                As a web3 launch pad, Gems helps you explore and purchase
                utility Tokens to various third party blockchain Projects and
                purchase the Project’s Tokens prior to the official launch of
                the Tokens, possibly at a discounted rate compared to the
                initial launch price of the Tokens. Gems is not the issuer of
                any of the tokens sold or otherwise made available on its
                Platform (except the $GEMS token) and makes no representation
                regarding the Projects, their Tokens, their teams or anyone
                associated therewith, including any content associated with the
                project and/or the Tokens displayed on the Service, and you bear
                responsibility for verifying the legitimacy, authenticity, and
                legality of the Tokens that you purchase.
              </p>
              <p className="darkpara">
                These Terms solely govern the use of our Service. There may be
                terms and conditions that apply to the Tokens' themselves set
                directly between buyers, sellers, and/or creators with respect
                to the Token including with respect to the use of the Token
                content and rights and obligations associated with a given Token
                ("Project Terms"). For example, when you click to get more
                details about any of the Tokens visible on Gems, you may notice
                a third-party link to Project Terms governing the use of the
                Token that you will be required to comply with. Gems does not
                set the Project Terms and is not party to any such Project
                Terms, which are solely between you and the Project.
              </p>
              <p className="darkpara">
                Projects are solely responsible for determining and establishing
                the price of a Token, inclusive of any applicable tax.
              </p>
              <p className="darkpara">
                For its Service, Gems may receive certain fees. Gems does not
                set, collect, or determine other applicable costs, fees, and
                expenses associated with buying and selling a Token, including
                but not limited to any Project earnings, gas, or transaction
                fees. These costs, fees, and expenses are paid directly to the
                Project and/or the Leader, blockchain validator, or other third
                party, as applicable. Because these costs, fees, and expenses
                are not collected by Gems, it cannot refund them.
              </p>
              <p className="darkpara">
                The Service may also contain links or functionality to access or
                use third-party websites (“Third-Party Websites”) and
                applications (“Third-Party Applications”), or otherwise display,
                include, or make available content, data, information, services,
                applications, or materials from third parties (“Third-Party
                Materials”). When you click on a link to, or access and use, a
                Third-Party Website or Third-Party Application, though we may
                not warn you that you have left our Service, you are subject to
                the terms and conditions (including privacy policies) of another
                website or destination. Such Third-Party Websites, Third-Party
                applications, and Third-Party Materials are not under the
                control of Gems, and may be “open” applications for which no
                recourse is possible. Gems is not responsible or liable for any
                Third-Party Websites, Third-Party applications, and Third-Party
                Materials. Gems provides links to these Third-Party Websites and
                Third-Party applications only as a convenience and does not
                review, approve, monitor, endorse, warrant, or make any
                representations with respect to Third-Party Websites or
                Third-Party applications, or their products or services or
                associated Third-Party Materials. You use all links in
                Third-Party Websites, Third-Party applications, and Third-Party
                Materials at your own risk.
              </p>
              <p className="darkpara">
                5.
                <span className="headingtext formarginleft">
                  Communication Preferences.
                </span>
              </p>
              <p className="darkpara">
                By creating an Account, you consent to receive electronic
                communications from Gems (e.g., via email or other types of
                messages). These communications may include notices about your
                Account (e.g., transactional information) and are part of your
                relationship with us. We may also send you promotional
                communications via email we think will be of interest to you.
                You understand that you are not required to provide this consent
                as a condition of using the Service and you may opt out of these
                communications through the Service or through your mobile
                device’s operating system (with the possible exception of
                important service announcements and administrative messages) by
                following the unsubscribe instructions provided or through your
                Account settings.
              </p>
              <p className="darkpara">
                6.
                <span className="headingtext formarginleft">
                  Indemnification
                </span>
              </p>
              <p className="darkpara">
                By agreeing to these Terms and accessing the Service, you agree,
                to the fullest extent permitted by applicable law, to indemnify,
                defend, and hold harmless Gems, and our respective past,
                present, and future employees, officers, directors, contractors,
                consultants, equity holders, suppliers, vendors, service
                providers, parent companies, subsidiaries, affiliates, agents,
                representatives, predecessors, successors, and assigns
                (individually and collectively, the “Gems Parties”), from and
                against all actual or alleged claims, damages, awards,
                judgments, losses, liabilities, obligations, taxes, penalties,
                interest, fees, expenses (including, without limitation,
                attorneys’ fees and expenses), and costs (including, without
                limitation, court costs, costs of settlement, and costs of
                pursuing indemnification and insurance), of every kind and
                nature whatsoever, whether known or unknown, foreseen or
                unforeseen, matured or unmatured, or suspected or unsuspected,
                in law or equity, whether in tort, contract, or otherwise
                (collectively, “Claims”), including, but not limited to, damages
                to property or personal injury, that are caused by, arise out of
                or are related to (a) your use or misuse of the Service (b) any
                Feedback you provide, (c) your violation or breach of any term
                of these Terms or applicable law, and (d) your violation of the
                rights of or obligations to a third party, including another
                user or third party, and (e) your negligence or wilful
                misconduct. You agree to promptly notify Gems of any Claims and
                cooperate with the Gems Parties in defending such Claims. You
                further agree that the Gems Parties shall have control of the
                defense or settlement of any Claims. THIS INDEMNITY IS IN
                ADDITION TO, AND NOT IN LIEU OF, ANY OTHER INDEMNITIES SET FORTH
                IN A WRITTEN AGREEMENT BETWEEN YOU AND GEMS.
              </p>

              <p className="darkpara">
                7.<span className="headingtext formarginleft">Disclaimers</span>
              </p>
              <p className="darkpara">
                YOUR ACCESS TO AND USE OF THE SERVICE IS AT YOUR OWN RISK. YOU
                UNDERSTAND AND AGREE THAT THE SERVICE IS PROVIDED ON AN “AS IS”
                AND “AS AVAILABLE” BASIS AND GEMS EXPRESSLY DISCLAIMS WARRANTIES
                OR CONDITIONS OF ANY KIND, EITHER EXPRESS OR IMPLIED. GEMS MAKE
                NO WARRANTY OR REPRESENTATION AND DISCLAIM ALL RESPONSIBILITY
                FOR WHETHER THE SERVICE: (A) WILL MEET YOUR REQUIREMENTS; (B)
                WILL BE AVAILABLE ON AN UNINTERRUPTED, TIMELY, SECURE, OR
                ERROR-FREE BASIS; OR (C) WILL BE ACCURATE, RELIABLE, COMPLETE,
                LEGAL, OR SAFE. GEMS DISCLAIMS ALL OTHER WARRANTIES OR
                CONDITIONS, EXPRESS OR IMPLIED, INCLUDING, WITHOUT LIMITATION,
                IMPLIED WARRANTIES OR CONDITIONS OF MERCHANTABILITY, FITNESS FOR
                A PARTICULAR PURPOSE, TITLE AND NON-INFRINGEMENT; (D) THAT THE
                TOKENS WILL BE SUITABLE FOR ANY PURPOSE, WILL ACCRUE OR HAVE ANY
                VALUE, ETC., OR THAT THEY WILL BE LISTED ON ANY CRYPTO EXCHANGE
                IN THE FUTURE. GEMS WILL NOT BE LIABLE FOR ANY LOSS OF ANY KIND
                FROM ANY ACTION TAKEN OR TAKEN IN RELIANCE ON MATERIAL OR
                INFORMATION, CONTAINED ON THE SERVICE. WHILE GEMS ATTEMPTS TO
                MAKE YOUR ACCESS TO AND USE OF THE SERVICE SAFE, GEMS CANNOT AND
                DOES NOT REPRESENT OR WARRANT THAT THE SERVICE, CONTENT, OR
                TOKENS, OR ANY OTHER CONTENT LINKED TO THE TOKENS OR OTHERWISE
                PROVIDED VIA ONE OF THE PROJECTS WHOSE TOKENS AER AVAILABLE FOR
                YOU TO PURCHASE VIA THE PLATFORM ARE FREE OF VIRUSES OR OTHER
                HARMFUL COMPONENTS. WE CANNOT GUARANTEE THE SECURITY OF ANY DATA
                THAT YOU DISCLOSE ONLINE. NO ADVICE OR INFORMATION, WHETHER ORAL
                OR OBTAINED FROM THE GEMS PARTIES OR THROUGH THE SERVICE, WILL
                CREATE ANY WARRANTY OR REPRESENTATION NOT EXPRESSLY MADE HEREIN.
                YOU ACCEPT THE INHERENT SECURITY RISKS OF PROVIDING INFORMATION
                AND DEALING ONLINE OVER THE INTERNET AND WILL NOT HOLD GEMS
                RESPONSIBLE FOR ANY BREACH OF SECURITY.
              </p>
              <p className="darkpara">
                WE WILL NOT BE RESPONSIBLE OR LIABLE TO YOU FOR ANY LOSS AND
                TAKE NO RESPONSIBILITY FOR, AND WILL NOT BE LIABLE TO YOU FOR,
                ANY USE OF OR LOSS OF USE OF TOKENS, CONTENT, AND/OR CONTENT
                LINKED TO OR ASSOCIATED WITH OR OTHERWISE PROVIDED VIA ONE OF
                THE PROJECTS WHOSE TOKENS ARE AVAILABLE FOR YOU TO PURCHASE VIA
                THE PLATFORM, INCLUDING BUT NOT LIMITED TO ANY LOSSES, DAMAGES,
                OR CLAIMS ARISING FROM: (A) USER ERROR, INCORRECTLY CONSTRUCTED
                TRANSACTIONS, OR MISTYPED ADDRESSES; (B) SERVER FAILURE OR DATA
                LOSS; (C) UNAUTHORIZED ACCESS OR USE; (D) ANY UNAUTHORIZED
                THIRD-PARTY ACTIVITIES, INCLUDING WITHOUT LIMITATION THE USE OF
                VIRUSES, PHISHING, BRUTEFORCING OR OTHER MEANS OF ATTACK AGAINST
                THE SERVICE OR TOKENS.
              </p>
              <p className="darkpara">
                NO GEMS PARTY IS RESPONSIBLE OR LIABLE FOR ANY SUSTAINED LOSSES
                OR INJURY DUE TO VULNERABILITY OR ANY KIND OF FAILURE, ABNORMAL
                BEHAVIOR OF SOFTWARE (E.G., WALLET, SMART CONTRACT), BLOCKCHAINS
                OR ANY OTHER FEATURES OF THE TOKENS. NO GEMS PARTY IS
                RESPONSIBLE FOR LOSSES OR INJURY DUE TO LATE REPORTS BY
                DEVELOPERS OR REPRESENTATIVES (OR NO REPORT AT ALL) OF ANY
                ISSUES WITH THE BLOCKCHAIN SUPPORTING THE TOKENS, INCLUDING
                FORKS, TECHNICAL NODE ISSUES OR ANY OTHER ISSUES HAVING LOSSES
                OR INJURY AS A RESULT.
              </p>
              <p className="darkpara">
                Some jurisdictions do not allow the exclusion of implied
                warranties in contracts with consumers, so the above exclusion
                may not apply to you.
              </p>
              <p className="darkpara">
                8.
                <span className="headingtext formarginleft">
                  Assumption of Risk.
                </span>
              </p>
              <p className="darkpara">You accept and acknowledge, that:</p>
              <p className="darkpara">
                <span className="headingtext formarginleft">a.</span> The value
                of a Token is subjective. Prices of Tokens are subject to
                volatility and fluctuations in the price of cryptocurrency can
                also materially and adversely affect Token prices. You
                acknowledge that you fully understand this subjectivity and
                volatility and that you may lose money.
              </p>
              <p className="darkpara">
                <span className="headingtext formarginleft">b.</span> You are
                responsible for any fees related to use of the Service, if any,
                including for actions you take on the blockchain, regardless of
                whether a successful transaction occurs, and that such fees are
                final and irreversible.
              </p>
              <p className="darkpara">
                <span className="headingtext formarginleft">c.</span> A lack of
                use or public interest in the creation and development of
                distributed ecosystems could negatively impact the development
                of those ecosystems and related applications, and could
                therefore also negatively impact the potential utility of the
                Tokens.
              </p>
              <p className="darkpara">
                <span className="headingtext formarginleft">d.</span> The
                regulatory regime governing blockchain technologies, tokens,
                cryptocurrency, and other crypto-based items is uncertain, and
                new regulations or policies may materially adversely affect the
                development of the Service and the utility of the Tokens.
              </p>
              <p className="darkpara">
                <span className="headingtext formarginleft">e.</span> You are
                solely responsible for determining what, if any, taxes apply to
                your transactions and to withhold, collect, report, and remit
                the correct amounts of taxes to the appropriate tax authorities.
                Gems is not responsible for determining, withholding,
                collecting, reporting, or remitting any taxes that apply to your
                Tokens or the sale/purchase thereof.
              </p>
              <p className="darkpara">
                <span className="headingtext formarginleft">f.</span> We do not
                have ownership or control of the smart contracts deployed by
                third parties, and are not responsible and make no guarantees
                regarding their operation and functionality.
              </p>
              <p className="darkpara">
                <span className="headingtext formarginleft">g.</span> We do not
                control the public blockchains that you are interacting with and
                we do not control certain smart contracts and protocols that may
                be integral to your ability to complete transactions on these
                public blockchains. Additionally, blockchain transactions are
                irreversible and Gems has no ability to reverse any transactions
                on the blockchain.
              </p>
              <p className="darkpara">
                <span className="headingtext formarginleft">h.</span> There are
                risks associated with using Internet and blockchain based
                products, including, but not limited to, the risk associated
                with hardware, software, and Internet connections, the risk of
                malicious software introduction, and the risk that third parties
                may obtain unauthorized access to your third-party wallet or
                Account. You accept and acknowledge that Gems will not be
                responsible for any communication failures, disruptions, errors,
                distortions or delays you may experience when using the Service
                or any Blockchain network, however caused.
              </p>
              <p className="darkpara">
                <span className="headingtext formarginleft">i.</span> The
                Service may rely on third-party platforms and/or vendors. If we
                are unable to maintain a good relationship with such platform
                providers and/or vendors; if the terms and conditions or pricing
                of such platform providers and/or vendors change; if we violate
                or cannot comply with the terms and conditions of such platforms
                and/or vendors; or if any of such platforms and/or vendors loses
                market share or falls out of favor or is unavailable for a
                prolonged period of time, access to and use of the Service may
                be directly affected.
              </p>
              <p className="darkpara">
                <span className="headingtext formarginleft">j.</span>IF YOU HAVE
                A DISPUTE WITH ANY LEADERS OR PROJECT TEAM, YOU RELEASE US FROM
                CLAIMS, DEMANDS, AND DAMAGES OF EVERY KIND AND NATURE, KNOWN AND
                UNKNOWN, ARISING OUT OF OR IN ANY WAY CONNECTED WITH SUCH
                DISPUTES. IN ENTERING INTO THIS RELEASE YOU EXPRESSLY WAIVE ANY
                PROTECTIONS (WHETHER STATUTORY OR OTHERWISE) THAT WOULD
                OTHERWISE LIMIT THE COVERAGE OF THIS RELEASE TO INCLUDE THOSE
                CLAIMS WHICH YOU MAY KNOW OR SUSPECT TO EXIST IN YOUR FAVOR AT
                THE TIME OF AGREEING TO THIS RELEASE.
              </p>
              <p className="darkpara">
                9.
                <span className="headingtext formarginleft">
                  Limitation of Liability.
                </span>
              </p>
              <p className="darkpara">
                TO THE FULLEST EXTENT PERMITTED BY LAW, YOU AGREE THAT IN NO
                EVENT WILL GEMS BE LIABLE TO YOU OR ANY THIRD PARTY (A) FOR ANY
                LOST PROFIT OR ANY INDIRECT, CONSEQUENTIAL, EXEMPLARY,
                INCIDENTAL, SPECIAL, OR PUNITIVE DAMAGES ARISING FROM THESE
                TERMS OR THE SERVICE, PRODUCTS OR THIRD-PARTY SITES AND
                PRODUCTS, OR FOR ANY DAMAGES RELATED TO LOSS OF REVENUE, LOSS OF
                PROFITS, LOSS OF BUSINESS OR ANTICIPATED SAVINGS, LOSS OF USE,
                LOSS OF GOODWILL, OR LOSS OF DATA, AND WHETHER CAUSED BY STRICT
                LIABILITY OR TORT (INCLUDING NEGLIGENCE), BREACH OF CONTRACT, OR
                OTHERWISE, EVEN IF FORESEEABLE AND EVEN IF GEMS OR ITS SERVICE
                PROVIDERS HAVE BEEN ADVISED OF THE POSSIBILITY OF SUCH DAMAGES;
                OR (B) FOR ANY OTHER CLAIM, DEMAND, OR DAMAGES WHATSOEVER
                RESULTING FROM OR ARISING OUT OF OR IN CONNECTION WITH THESE
                TERMS OF THE DELIVERY, USE, OR PERFORMANCE OF THE SERVICE.
              </p>
              <p className="darkpara">
                NOTWITHSTANDING ANYTHING TO THE CONTRARY CONTAINED HEREIN, TO
                THE FULLEST EXTENT PERMITTED BY LAW, IN NO EVENT SHALL THE
                MAXIMUM AGGREGATE LIABILITY OF GEMS ARISING OUT OF OR IN ANY WAY
                RELATED TO THESE TERMS, THE ACCESS TO AND USE OF THE SERVICE,
                EXCEED THE AMOUNT RECEIVED BY GEMS FOR ITS SERVICE TO YOU
                DIRECTLY RELATING TO THE ITEMS THAT ARE THE SUBJECT OF THE
                CLAIM. THE FOREGOING LIMITATIONS WILL APPLY EVEN IF THE ABOVE
                STATED REMEDY FAILS OF ITS ESSENTIAL PURPOSE.
              </p>
              <p className="darkpara">
                10.
                <span className="headingtext formarginleft">Termination</span>
              </p>
              <p className="darkpara">
                If you breach any of the provisions of these Terms, all licenses
                granted by Gems will terminate automatically. Additionally,
                notwithstanding anything contained in these Terms, we reserve
                the right, with or without notice and in our sole discretion, to
                suspend, restrict, disable, terminate, or delete your Account
                and/or your ability to access or use the Service (or any part of
                the foregoing) at any time and for any or no reason, and you
                acknowledge and agree that we shall have no liability or
                obligation to you in such event and that you will not be
                entitled to a refund of any amounts that you have already paid
                to us. If we terminate your Account or restrict your access or
                use of the Service, you retain ownership of your Tokens. You may
                still access your Tokens through public blockchains and other
                web3 wallets, platforms, and/or websites. All sections which by
                their nature should survive the termination of these Terms shall
                continue in full force and effect subsequent to and
                notwithstanding any termination of these Terms by Gems or you.
                Termination will not limit any of Gems’s other rights or
                remedies at law or in equity. You agree that a breach of these
                Terms will cause irreparable injury to Gems for which monetary
                damages would not be an adequate remedy and Gems shall be
                entitled to equitable relief in addition to any remedies it may
                have hereunder or at law without a bond, other security, or
                proof of damages.
              </p>
              <p className="darkpara">
                11.<span className="headingtext formarginleft">General</span>
              </p>
              <p className="darkpara">
                These Terms are governed by the laws of Hong Kong, excluding
                rules as to choice and conflicts of law and the competent courts
                in Hong Kong will have exclusive jurisdiction. If any part of
                these Terms is deemed unlawful, void or for any reason
                unenforceable, then that provision shall be deemed to be
                severable from the rest of these Terms and shall not affect the
                validity and enforceability of any of the remaining provisions
                of these Terms. In such cases, the part deemed invalid or
                unenforceable shall be construed in a manner consistent with
                applicable law to reflect, as closely as possible, the original
                intent of the parties. No waiver by us of a breach of any of the
                provisions of terms of these Terms shall be construed as a
                waiver of any preceding or succeeding breach of any of the
                provisions of these Terms. Nothing in these Terms shall be
                construed as creating any agency, partnership, trust
                arrangement, fiduciary relationship or any other form of joint
                enterprise between you and Gems. These Terms contain the entire
                agreement between Gems and you relating to your use of the
                Services and supersedes any and all prior agreements between
                Gems and you in relation to the same. You confirm that, in
                agreeing to accept these Terms, you have not relied on any
                representation except as has expressly been made by Gems in
                these Terms. You may not assign your rights or delegate your
                obligations under these Terms without Gems’ prior written
                consent. Any purported assignment contrary to this section will
                be null and void. Gems may assign its obligations hereunder.
                Except as otherwise provided herein, these Terms are intended
                solely for the benefit of the parties and are not intended to
                confer third-party beneficiary rights upon any other person or
                entity.
              </p>
              <p className="darkpara">
                In addition to the implementation of KYT (Know Your
                Transaction), a KYB (Know Your Business) process will also be
                enacted, facilitated by a trusted third-party service provider.
                This process will ensure thorough business verification for all
                entities interacting with the platform, supporting our
                compliance with international regulations. Furthermore, any
                funds or transactions received from jurisdictions classified as
                "blacklisted" or high-risk countries will be subject to enhanced
                scrutiny, including the reporting of any suspicious activities
                or transactions to the relevant authorities.
              </p>
            </div>
          </div>
          <div className="material-textfield">
            <input
              type="text"
              placeholder="Enter your email address"
              onChange={inputField1Handler5}
              value={inputFeild6}
            />
          </div>

          <div className="checkboxmainnnnnn">
            <label class="checkbox" for="ch1">
              <input
                type="checkbox"
                onChange={inputField1Handler2}
                id="ch1"
              ></input>
              <span class="checkmark"></span>
            </label>
            <p className="checkboxpara">
              I have carefully reviewed the Private Sale Agreement, including
              its disclaimers, and fully agree to abide by its terms and
              conditions.
            </p>
          </div>

          {cheked && (
            <div className="checkboxmainnnnnn">
              <label class="checkbox" for="ch2">
                <input
                  type="checkbox"
                  id="ch2"
                  onChange={inputField1Handler3}
                />
                <span class="checkmark"></span>
              </label>
              <p className="checkboxpara">
                I hereby confirm that I am not a citizen or a resident of the
                United States of America or the State of Israel.
              </p>
            </div>
          )}
          {cheked && cheked1 ? (
            <div className="checkboxmainnnnnn">
              <label class="checkbox" for="ch3">
                <input
                  type="checkbox"
                  id="ch3"
                  onChange={inputField1Handler4}
                />
                <span class="checkmark"></span>
              </label>
              <p className="checkboxpara">
                I agree to receive communication and marketing emails from Gems
              </p>
            </div>
          ) : (
            ""
          )}
          {cheked && cheked1 && checkedNew1 && cheked2 ? (
            <button onClick={userLogin} className="continuebutton">
              continue
            </button>
          ) : (
            <button className="disablebutton">continue</button>
          )}
        </Modal.Body>
      </Modal>

      <Modal
        className="connectwallet-modal"
        show={show1}
        onHide={handleClose1}
        centered
      >
        <Modal.Header closeButton>
          <Modal.Title>Connect Wallet</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="twice-btns">
            <button className="forhideee" onClick={connectMetaMask1}>
              <img src="\assets\metamask.svg" alt="img" className="img-fluid" />
              <h6>Metamask</h6>
            </button>
            {/* {TomiPayBol == 'true' ?
              <button onClick={trustWallet}>
                <img
                  src="\assets\tomiPAYLogo.png"
                  alt="img"
                  className="img-fluid payyy"
                />
                <h6>tomiPAY</h6>
              </button>
              : */}
            <button onClick={trustWallet}>
              <img
                src="\assets\walletconnect.svg"
                alt="img"
                className="img-fluid"
              />
              <h6>WalletConnect</h6>
            </button>

            {/* } */}
          </div>
        </Modal.Body>
      </Modal>
    </>
  );
};

export default Login;
